var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08182 20.6147L2.08434 20.6086L2.09556 20.5812C2.10568 20.5563 2.12092 20.5184 2.14037 20.4692C2.17929 20.3707 2.23491 20.2269 2.30007 20.05C2.43092 19.6945 2.59759 19.2121 2.7446 18.6968C2.89316 18.1761 3.0133 17.6504 3.06302 17.2014C3.08779 16.9778 3.0926 16.7943 3.08173 16.6526C3.07639 16.583 3.06781 16.5311 3.05914 16.4946C3.05096 16.4601 3.04425 16.4457 3.04425 16.4457C2.37798 15.1053 2.00391 13.595 2.00391 12C2.00391 6.47715 6.48105 2 12.0039 2C17.5267 2 22.0039 6.47715 22.0039 12C22.0039 17.5228 17.5267 22 12.0039 22H3.00471C2.67039 22 2.3581 21.8329 2.17263 21.5548C1.98721 21.2767 1.95297 20.9244 2.08136 20.6158L2.08182 20.6147Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircle);
export default __webpack_public_path__ + "static/media/message-circle.0d89b13bfd90b0a63f2e57d47e1c4c1f.svg";
export { ForwardRef as ReactComponent };